export const HOMEPAGE_MINIMUM_PRODUCTS = 3;
export const HOMEPAGE_MAX_PRODUCTS = 6;
